// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3SJdp","productName":"Table_productName__3p5b5"};